import {css} from "styled-components";

export const AnnouncementStyle = css`
  .modal-announcement {
    .ant-modal-content {
      border-radius: 8px;

      .ant-modal-close {
        color: rgba(0, 0, 0, 75%);

        .ant-modal-close-x {
          font-size: 22px;
        }
      }

      .content {
        padding-top: 30px;
        padding-bottom: 0;
        text-align: center;

        p.icon {
          img {
            display: inline-block;
            width: 80px;
          }
        }

        h1 {
          padding: 8px 0;
          font-size: 20px;
          font-weight: 800;
          line-height: 1.3;
          text-align: left;
        }

        p.description {
          font-size: 14px;
          color: rgba(0, 0, 0, 60%);
          text-align: left;
        }

        .ant-carousel {
          .slick-dots-bottom {
            bottom: -16px;
          }

          .slick-dots {
            li {
              button {
                background: black;
              }
            }
          }
        }
      }
    }
  }
`;
